import React from "react";
import ProductWithTechMap from "./ProductWithTechMap/ProductWithTechMap";
import OtherWriteOffProducts from "./OtherWriteOffProducts/OtherWriteOffProducts";
import { CombinedProductsInterface } from "../../../../interfaces/interfaces";
import { ProductWriteOffInput } from "@me-team/host/main/graphql/types";

type ProductsToWriteOffProps = {
    combinedProducts: CombinedProductsInterface;
    changeProductsToWriteOff: (
        productToWriteOff: ProductWriteOffInput,
        changedField: keyof ProductWriteOffInput,
        isFromTechMap?: boolean,
        techMapId?: number
    ) => void;
    removeProductFromWriteOff: (productId: number, isProductFromTechMap: boolean, techMapId?: number) => void;
};

const ProductsToWriteOff: React.FC<ProductsToWriteOffProps> = (props) => {
    return (
        <>
            {props.combinedProducts.productFromTechMap?.length > 0 && (
                <ProductWithTechMap
                    changeProductsToWriteOff={props.changeProductsToWriteOff}
                    productFromTechMap={props.combinedProducts.productFromTechMap}
                    removeProductFromWriteOff={props.removeProductFromWriteOff}
                />
            )}
            {props.combinedProducts.addedProductToWriteOff?.length > 0 && (
                <>
                    <OtherWriteOffProducts
                        addedProducts={props.combinedProducts.addedProductToWriteOff}
                        changeProductsToWriteOff={props.changeProductsToWriteOff}
                        removeProductFromWriteOff={props.removeProductFromWriteOff}
                    />
                </>
            )}
        </>
    );
};

export default React.memo(ProductsToWriteOff);
